import { render, staticRenderFns } from "./messageBodyList.vue?vue&type=template&id=49794679&scoped=true&"
import script from "./messageBodyList.vue?vue&type=script&lang=js&"
export * from "./messageBodyList.vue?vue&type=script&lang=js&"
import style0 from "./messageBodyList.vue?vue&type=style&index=0&id=49794679&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49794679",
  null
  
)

export default component.exports